export const taxTypes = <const>['sales', 'vat', 'other'];
export type TaxType = (typeof taxTypes)[number];

export interface TaxRate {
  rate: number;
  validFrom: Date | string;
}
export interface TaxItem {
  _id?: string;
  name: string;
  taxType: TaxType;
  rates: TaxRate[];
}

export type DateComponents = {
  day: number;
  month: number;
  year: number;
};

export interface TaxItemResponse {
  _id: string;
  taxType: TaxType;
  name: string;
  rates: {
    rate: number;
    validFrom: DateComponents;
  }[];
}

export type GetTaxesResponse = TaxItemResponse[];

export interface CreateTaxPayload {
  storageLocationId: string;
  taxItem: TaxItem;
}

export interface UpdateTaxPayload {
  storageLocationId: string;
  taxItem: TaxItem;
  taxItemId: string;
}

export interface DeleteTaxPayload {
  storageLocationId: string;
  taxItemId: string;
}
